import { render, staticRenderFns } from "./iframe-upload.vue?vue&type=template&id=54c231f6"
import script from "./iframe-upload.vue?vue&type=script&lang=js"
export * from "./iframe-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports